var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighRentalIncome = function SvgHighRentalIncome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 58"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#high-rental-income_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#high-rental-income_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.1 23.258a.88.88 0 0 1 .284-.647l13.13-12.091a1 1 0 0 1 .146-.11l.047-.027a.9.9 0 0 1 .528-.12l1.855.169a.9.9 0 0 1 .494.21l13.991 12.043a.88.88 0 0 1 .306.666v19.303a.88.88 0 0 1-.262.626l-1.235 1.217a.88.88 0 0 1-.63.253l-27.787-.421a.88.88 0 0 1-.866-.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#high-rental-income_svg__c)",
    fillOpacity: 0.6,
    d: "M14.1 23.258a.88.88 0 0 1 .284-.647l13.13-12.091a1 1 0 0 1 .146-.11l.047-.027a.9.9 0 0 1 .528-.12l1.855.169a.9.9 0 0 1 .494.21l13.991 12.043a.88.88 0 0 1 .306.666v19.303a.88.88 0 0 1-.262.626l-1.235 1.217a.88.88 0 0 1-.63.253l-27.787-.421a.88.88 0 0 1-.866-.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.66,
    d: "M27.596 10.755a.55.55 0 0 1 .712 0L43.04 23.304a.55.55 0 0 1 .192.418v20.154a.55.55 0 0 1-.548.55H13.222a.55.55 0 0 1-.55-.55V23.722c0-.161.07-.314.193-.418z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.994 33.874a1.32 1.32 0 0 0 1.77 1.955l-.885-.978zm9.033-6.402.852-1.007-.881-.746-.856.775zm3.608 3.054-.852 1.006.899.761.857-.807zM31.01 19.825l.823-1.03-.893-.715-.834.784zm4.252 3.399-.824 1.03.945.755.834-.876zM7.879 34.85l.886.978 8.148-7.38-.886-.977-.886-.978-8.147 7.38zm8.148-7.38-.852 1.008 3.608 3.053.852-1.006.853-1.007-3.609-3.054zm3.608 3.055.904.96 11.374-10.7-.904-.961-.904-.961-11.373 10.7zM31.01 19.825l-.824 1.03 4.252 3.399.824-1.03.823-1.03-4.252-3.4zm4.252 3.399.955.91L46.47 13.367l-.955-.91-.955-.91-10.254 10.766z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m45.919 16.69-4.771-4.338a.44.44 0 0 1 .22-.759l5.179-.904a.44.44 0 0 1 .514.467l-.408 5.242a.44.44 0 0 1-.734.291"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#895FFC",
    d: "M35.18 49.836a.55.55 0 0 1-.058.245c-.448 1.46-3.423 2.59-7.028 2.59s-6.58-1.13-7.027-2.59a.55.55 0 0 1-.059-.245v-4.938h.02q-.02.114-.02.229c0 1.641 3.173 2.972 7.086 2.972s7.087-1.33 7.087-2.972q0-.115-.021-.229h.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#high-rental-income_svg__d)",
    fillOpacity: 0.6,
    d: "M35.18 49.836a.55.55 0 0 1-.058.245c-.448 1.46-3.423 2.59-7.028 2.59s-6.58-1.13-7.027-2.59a.55.55 0 0 1-.059-.245v-4.938h.02q-.02.114-.02.229c0 1.641 3.173 2.972 7.086 2.972s7.087-1.33 7.087-2.972q0-.115-.021-.229h.02z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.094,
    cy: 45.127,
    fill: "#fff",
    rx: 7.086,
    ry: 2.972
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#895FFC",
    d: "M35.18 44.1a.55.55 0 0 1-.058.245c-.448 1.46-3.423 2.59-7.028 2.59s-6.58-1.13-7.027-2.59a.55.55 0 0 1-.059-.245v-4.938h.02q-.02.114-.02.229c0 1.641 3.173 2.972 7.086 2.972s7.087-1.33 7.087-2.972q0-.115-.021-.229h.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#high-rental-income_svg__e)",
    fillOpacity: 0.8,
    d: "M35.18 44.1a.55.55 0 0 1-.058.245c-.448 1.46-3.423 2.59-7.028 2.59s-6.58-1.13-7.027-2.59a.55.55 0 0 1-.059-.245v-4.938h.02q-.02.114-.02.229c0 1.641 3.173 2.972 7.086 2.972s7.087-1.33 7.087-2.972q0-.115-.021-.229h.02z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.094,
    cy: 39.391,
    fill: "#fff",
    rx: 7.086,
    ry: 2.972
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#895FFC",
    d: "M35.18 38.366a.55.55 0 0 1-.058.245c-.448 1.46-3.423 2.59-7.028 2.59s-6.58-1.13-7.027-2.59a.55.55 0 0 1-.059-.245v-4.938h.02q-.02.114-.02.229c0 1.641 3.173 2.971 7.086 2.971s7.087-1.33 7.087-2.971q0-.115-.021-.229h.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#high-rental-income_svg__f)",
    fillOpacity: 0.8,
    d: "M35.18 38.366a.55.55 0 0 1-.058.245c-.448 1.46-3.423 2.59-7.028 2.59s-6.58-1.13-7.027-2.59a.55.55 0 0 1-.059-.245v-4.938h.02q-.02.114-.02.229c0 1.641 3.173 2.971 7.086 2.971s7.087-1.33 7.087-2.971q0-.115-.021-.229h.02z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.094,
    cy: 33.657,
    fill: "#A888FF",
    rx: 7.086,
    ry: 2.972
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.094,
    cy: 33.657,
    fill: "url(#high-rental-income_svg__g)",
    fillOpacity: 0.8,
    rx: 7.086,
    ry: 2.972
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "high-rental-income_svg__c",
    x1: 50.227,
    x2: -19.739,
    y1: 26.944,
    y2: -3.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "high-rental-income_svg__d",
    x1: 28.171,
    x2: 28.094,
    y1: 38.6,
    y2: 52.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "high-rental-income_svg__e",
    x1: 28.171,
    x2: 28.171,
    y1: 26.727,
    y2: 48.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    stopColor: "#4E90F9",
    stopOpacity: 0.692
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "high-rental-income_svg__f",
    x1: 28.171,
    x2: 28.171,
    y1: 34.643,
    y2: 42.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "high-rental-income_svg__g",
    x1: 28.171,
    x2: 28.235,
    y1: 36.841,
    y2: 22.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "high-rental-income_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h58v58H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "high-rental-income_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.668 6.5h62v47.05h-62z"
  })))));
};
export default SvgHighRentalIncome;